import React from 'react'
import {Bar, Chart} from 'react-chartjs-2';
import ReactTooltip from 'react-tooltip'
import {findIt, roundFloat} from './Util'

export default class Detail extends React.Component {

  constructor(props) {
    super(props)
    Chart.pluginService.clear()
    this.state = {
      detail: props.detail
    }
  }

  printDetail() {

    var domClone = document.getElementById("c-modal__content").cloneNode(true);
    var printSection = document.getElementById("r-wrapper");
    var noPrint = document.getElementById("l-wrapper");
    printSection.innerHTML = "";
    printSection.appendChild(domClone);

    noPrint.style.display = "none";
    for(var i=0; i<document.getElementById("c-modal__content").getElementsByTagName('canvas').length; i++){
      var canvasf = document.getElementById("c-modal__content").getElementsByTagName('canvas')[i];
      var canvast = printSection.getElementsByTagName('canvas')[i];
      var image = canvasf.getContext('2d').getImageData(0, 0, canvasf.width, canvasf.height);
      canvast.getContext('2d').putImageData(image, 0, 0);
    }



    window.print();

    printSection.innerHTML = "";
    noPrint.style.display = "block";
    return false;
  }

  render() {

    const detail = this.state.detail;
    const u = detail.unit;
    const dg = detail.detail_genes;
    const unitName = u.name;
    const unitSummary = u.summary.split('<br>');
    const unitExplanation = u.explanation.split('<br>');
    const unitOnsetAge = u.onset_age ? u.onset_age.split('<br>') : null;
    const unitPrevention = u.prevention.split('<br>');
    const levelName = detail.split_level_name[0] + detail.split_level_name[1] + detail.split_level_name[2];
    const references = u.references;

    const genes = [];
    u.descriptions.map(d => {

      const cellSelect = findIt(dg, 'ghnumber', d.gene_master.ghnumber)[0].value;

      const gene = new Map();
      gene.set('gh_number', d.gene_master.ghnumber);
      gene.set('gene_name', d.gene_name);
      gene.set('explanation', d.explanation);
      gene.set('evidence_rank', d.evidence_rank);
      gene.set('type_1', d.gene_master.alleles[0].value);
      gene.set('type_1_freq', roundFloat((d.gene_master.alleles[0].population_frequency * 100), 2));
      gene.set('type_1_style', 'nomcell' + (cellSelect === d.gene_master.alleles[0].value ? ' cell_select' : ''));
      gene.set('type_2', d.gene_master.alleles[1].value);
      gene.set('type_2_freq', roundFloat((d.gene_master.alleles[1].population_frequency * 100), 2));
      gene.set('type_2_style', 'nomcell' + (cellSelect === d.gene_master.alleles[1].value ? ' cell_select' : ''));
      gene.set('type_3', d.gene_master.alleles[2].value);
      gene.set('type_3_freq', roundFloat((d.gene_master.alleles[2].population_frequency * 100), 2));
      gene.set('type_3_style', 'nomcell' + (cellSelect === d.gene_master.alleles[2].value ? ' cell_select' : ''));
      genes.push(gene);
      return null;
    });

    const populationId = detail.population_id;
    const oddsConversion = detail.odds_conversion;
    const noteInResult = u.note_in_result;
    const remarks = u.remarks;

    const backgroundColorSet = [
      'rgba(93, 175, 198, 0.7)',
      'rgba(145, 210, 188, 0.7)',
      'rgba(255, 232, 130, 0.7)',
      'rgba(242, 188, 126, 0.7)',
      'rgba(235, 152, 130, 0.7)']
    const borderColorSet = [
      'rgba(93, 175, 198, 0.9)',
      'rgba(145, 210, 188, 0.9)',
      'rgba(255, 232, 130, 0.9)',
      'rgba(242, 188, 126, 0.9)',
      'rgba(235, 152, 130, 0.9)']

    const barData = [];
    const barDataLabel = [];
    const backgroundColors = [];
    const borderColors = [];
    let myindex = null;
    let workIndex = 0;
    let yAxesMax = 0;

    u.populations.forEach(p => {
      barData.push(roundFloat(p.frequency * 100, 2));
      barDataLabel.push(roundFloat(p.frequency * 100, 2) + ' %');
      backgroundColors.push(backgroundColorSet[p.level_id % 10 - 1]);
      borderColors.push(borderColorSet[p.level_id % 10 - 1]);
      if (populationId === p.id) {
        myindex = workIndex;
      }
      if (yAxesMax < (p.frequency * 100)) {
        yAxesMax = p.frequency * 100;
      }
      workIndex += 1;
    });

    const data = {
      myindex: myindex,
      labels: barDataLabel,
      // labels: ['', '', '', '', '', '', '', '', '', '', ''],
      datasets: [
        {
          backgroundColor: backgroundColors,
          borderColor: borderColors,
          borderWidth: 1,
          data: barData
        }
      ]
    };



    const options = {
      showAllTooltips: true,
      scales: {
        xAxes: [{
          display: false,
          barPercentage: 1.0,
          categoryPercentage: 1.0,
          scaleLabel: {
            display: false
          }
        }],
        yAxes: [{
          display: true,
          ticks: {
            beginAtZero: true,
            steps: 5,
            stepValue: 5,
            // max: Math.floor(yAxesMax + 5)
          }
        }]
      },
      title: {
        display: false
      },
      legend: {
        display: false
      },
      tooltips: {
        responsive: true,
        backgroundColor: 'rgba(255, 48, 48, 1.0)',
        callbacks: {
          label: function (tooltipItems, data) {
            if (tooltipItems.index === data.myindex) {
              return '';
            } else {
              return data.labels[tooltipItems.index];
            }
          },
          title: function (tooltipItems, data) {
            if (tooltipItems[0].index === data.myindex) {
              return 'あなたの判定結果 ' + data.labels[data.myindex];
            } else {
              return '';
            }
          }
        }
      }
    }

    Chart.pluginService.register({
      beforeRender: function (chart) {
        if (chart.config.options.showAllTooltips) {
          chart.pluginTooltips = [];
          chart.config.data.datasets.forEach(function (dataset, i) {
            chart.getDatasetMeta(i).data.forEach(function (sector, j) {
              chart.pluginTooltips.push(new Chart.Tooltip({
                _chart: chart.chart,
                _chartInstance: chart,
                _data: chart.data,
                _options: chart.options.tooltips,
                _active: [sector]
              }, chart));
            });
          });
          chart.options.tooltips.enabled = false;
        }
      }, afterDraw: function (chart, easing) {
        if (chart.config.options.showAllTooltips) {
          if (!chart.allTooltipsOnce) {
            if (easing !== 1) {
              return;
            }
            chart.allTooltipsOnce = true;
          }
          let cnt = 0;
          // turn on tooltips
          chart.options.tooltips.enabled = true;
          Chart.helpers.each(chart.pluginTooltips, function (tooltip) {
            if (cnt === data.myindex){//data.myindex){
              tooltip.initialize();
              tooltip.update();
              tooltip.pivot();
              tooltip.transition(easing).draw();
              chart.options.tooltips.enabled = true;
            }
            cnt = cnt + 1;
          });
        }
      }
    });

    let loopKey = 0;
    return (
      <div className="wrap">

        <div className="detail_header">
          <div className="cfx">
            <h2 className="header_title">{unitName}</h2>
            <div className="header_btnwrap">
              {/* <span className="btn">検査結果についてレビューを投稿する</span> */}
              {<span className="btn detail_print" onClick={this.printDetail.bind()}>印刷する</span>}
            </div>
          </div>
        </div>

        <div className="detailwrap">
          {u.id !== 1022 ? (
            <div className="sect">
              <h3>あなたの判定結果</h3>
              <p className="detail_risk_result">{levelName}</p>
                {(() => {
                  if (noteInResult !== null) {
                    return <div className="detail_notes">※{noteInResult}</div>
                  } else {
                    return null
                  }
                })()}
              {(() => {
                if (oddsConversion !== null) {
                  return <div className="detail_odds"><span data-tip data-for='odds_data'>（オッズ比は{oddsConversion}です）※ </span>
                      <ReactTooltip id='odds_data' type='dark' effect='solid'>
                          <div className="odds_text" style={{maxWidth: 450 + "px"}}>
                            <p>当社ではリスク評価にオッズ比を使用しております。<br/>
                              オッズ比とは、対象となる遺伝子型を持つ集団に対して、あなたと同じ遺伝子型を持つ人が発症した比率を表す数値です。オッズ比が1より大きいほど遺伝的に高いリスクであると考えられます。
                            </p>
                          </div>
                      </ReactTooltip>
                    </div>
                } else {
                  return null
                }
              })()}

              <div className="canvaswrap">
                <div id="Chart2" width="100%"><Bar data={data} options={options}/></div>
                <div className="indicate_low">←LOW</div>
                <div className="indicate_high">HIGH→</div>
              </div>
            </div>
          ) : (
            <div className="sect">
              <h3>あなたの判定結果</h3>
              <p className="detail_risk_result">{levelName}</p>
                {(() => {
                  if (noteInResult !== null) {
                    return <div className="detail_notes">{noteInResult}</div>
                  } else {
                    return null
                  }
                })()}
            </div>
          )}

          <div className="sect">
            <h3>結果説明</h3>
            <div className="descrpt">
              <p>
              {unitExplanation.length > 0 && unitExplanation.map(s => {
                return (<span key={"unitExplanation" + loopKey++}>{s}<br/></span>)
              })}
              </p>
            </div>

          </div>

          <div className="sect">
            <h3>項目概要</h3>
            <div className="descrpt">
              <p>
                {unitSummary.length > 0 && unitSummary.map(s => {
                  return (<span key={"unitSummary" + loopKey++}>{s}<br/></span>)
                })}
              </p>
            </div>
          </div>

          {unitOnsetAge && unitOnsetAge[0] !== '-' && (
            <div className="sect">
              <h3>発症年齢・発症率について</h3>
              <div className="descrpt">
                <p>
                  {unitOnsetAge.length > 0 && unitOnsetAge.map(s => {
                    return (<span key={"unitOnsetAge" + loopKey++}>{s}<br/></span>)
                  })}
                </p>
              </div>
            </div>)
          }

          <div className="sect">
            {u.figures.length > 0 && u.figures.map(f => {
              return (
                <div>
                  <p className="center"><img src={`https://s3-ap-northeast-1.amazonaws.com/genesis2/images/detail/${f}`} alt="項目概要"/></p>
                </div>)
            })}
          </div>


          <div className="sect">
            <h3>予防と対策</h3>
            <div className="descrpt">
              <p>
                {unitPrevention.length > 0 && unitPrevention.map(s => {
                  return (<span key={"unitPrevention" + loopKey++}>{s}<br/></span>)
                })}
              </p>
            </div>
          </div>


          <div className="sect">
            <h3>遺伝子多型の頻度情報</h3>
            <div className="inddata">
              <table>
                <thead>
                <tr>
                  <th scope="col">多型部位</th>
                  <th scope="col">関連遺伝子</th>
                  <th scope="col">1st（頻度）</th>
                  <th scope="col">2nd（頻度）</th>
                  <th scope="col">3rd（頻度）</th>
                </tr>
                </thead>
                <tbody>
                {genes.map(f => {
                    return (
                      <tr key={Math.random()}>
                        <td className="inddata_part" data-label="多型部位">{f.get("gh_number")}</td>
                        <td className="nomcell" data-label="関連遺伝子">{f.get("gene_name")}</td>
                        <td className={f.get("type_1_style")} data-label="1st（頻度）">{f.get("type_1")}({f.get("type_1_freq")}%)</td>
                        <td className={f.get("type_2_style")} data-label="2nd（頻度）">{f.get("type_2")}({f.get("type_2_freq")}%)</td>
                        <td className={f.get("type_3_style")} data-label="3rd（頻度）">{f.get("type_3")}({f.get("type_3_freq")}%)</td>
                      </tr>);
                  }
                )}
                </tbody>
              </table>
            </div>
          </div>

          <div className="sect">
            <h3>解析遺伝子情報</h3>
            <div className="inddata">
              <table>
                <thead>
                <tr>
                  <th scope="col">多型部位</th>
                  <th scope="col">関連遺伝子</th>
                  <th scope="col">説明</th>
                  {u.id !== 1022 ? (
                  <th scope="col">信頼性<span data-tip data-for='evidence_rank'> (※) </span>
                    <ReactTooltip id='evidence_rank' type='dark' effect='solid' place="bottom">
                      <div className="evidence_rank_text">
                        <h3>信頼性について</h3>
                        <ul>
                          <li>1. P値の評価（5 x 10<sup>-8</sup>以下であるか）</li>
                          <li>2. 人種の評価（アジア人、日本人を対象にしているか）</li>
                          <li>3. 母集団の大きさの評価（1000人以上であるか）</li>
                          <li>上記3点の総合評価を基に信頼性が高い順に3、2、1と定義しております。</li>
                        </ul>
                      </div>
                    </ReactTooltip>
                  </th> ) : null}
                </tr>
                </thead>
                <tbody>
                {genes.map(f => {
                    return (
                      <tr key={Math.random()}>
                        <td className="inddata_part" data-label="多型部位">{f.get("gh_number")}</td>
                        <td className="nomcell" data-label="関連遺伝子">{f.get("gene_name")}</td>
                        <td className="inddata_descript" data-label="説明"><p>{f.get("explanation")}</p></td>
                        {u.id !== 1022 ?
                          (<td className="nomcell" data-label="信頼性(※)">{f.get("evidence_rank")}</td>)
                        : null}
                      </tr>);
                  }
                )}
                </tbody>
              </table>
              {u.id !== 1022 ? (
              <div className="sp_only">
                <h4>※信頼性について</h4>
                <ul>
                  <li>1. P値の評価（5 x 10<sup>-8</sup>以下であるか）</li>
                  <li>2. 人種の評価（アジア人、日本人を対象にしているか）</li>
                  <li>3. 母集団の大きさの評価（1000人以上であるか）</li>
                  <li>上記3点の総合評価を基に信頼性が高い順に3、2、1と定義しております。</li>
                </ul>
              </div>
              ) : null }
            </div>
          </div>


          <div className="sect">
            <h3>参考文献</h3>
            <div className="descrpt">
              <ul>
                {references.map(ref =>
                  <li key={ref.id}>{ref.title}</li>
                )}
              </ul>
            </div>
          </div>
          {(() => {
            if (remarks !== null) {
              return <div className="sect">
              <h3>備考</h3>
              <div className="descrpt">
                <ul>
                予測される遺伝子型 は、結果を評価するための異なる計算方法に基づいています。精度は、提出された検体の質によって異なる場合があります。
                </ul>
              </div>
            </div>
            } else {
              return null
            }
          })()}

        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Detail.js